import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ClientTable } from './components';

export default function ClientsPage() {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> Clients </title>
        </Helmet>
        <ClientTable />
      </QueryClientProvider>
    </>
  );
}
